import { useFormContext, Controller } from 'react-hook-form'
import { Input } from '@cb/apricot-react'
import { isEmpty } from 'lodash'
import { FIELD_RECOVERY_EMAIL } from '../constants'
import { validateEmail, validateFieldState } from '../validations'

function BfsRecoveryEmail() {
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={FIELD_RECOVERY_EMAIL}
      rules={{
        validate: value => (!isEmpty(value) ? validateEmail(value) : undefined),
      }}
      render={({
        field: { onChange, onBlur, value, disabled, name },
        fieldState: { invalid, isDirty, isTouched, error },
      }) => (
        <Input
          label="Recovery email"
          name={name}
          value={value}
          onChange={value => onChange(value)}
          onBlur={value => onBlur(value)}
          clearable={false}
          floating={false}
          autoComplete="off"
          maxLength="50"
          disabled={disabled}
          validation={validateFieldState({
            invalid,
            isDirty,
            isTouched,
            error,
            value,
          })}
          validationMsg={error?.message}
        />
      )}
    />
  )
}

export default BfsRecoveryEmail
